export default __webpack_public_path__ + "static/media/FREE_GONOGO_ICONA.5c78c1a7.svg";